import React from 'react';
import styles from './ErrorComponent.module.scss';
import { CloseOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import classNames from 'classnames';
const ErrorComponent = ({ errors, clearErrors, className }) => {
    if (errors.length <= 0)
        return null;
    return (React.createElement("div", { className: classNames(styles.error, className) },
        React.createElement("div", { className: styles.errorCross, onClick: clearErrors },
            React.createElement(CloseOutlined, null)),
        React.createElement("div", { className: styles.errorsList }, errors.map((err, ind) => (React.createElement("div", { key: ind }, err))))));
};
export default observer(ErrorComponent);
